var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCrossRed = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 26,
    rx: 3,
    fill: "#FF0505",
    fillOpacity: 0.11
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.364 11.9498L18.3138 7L19.728 8.41421L14.7782 13.364L19.728 18.3137L18.3138 19.7279L13.364 14.7782L8.41422 19.7279L7 18.3137L11.9498 13.364L7 8.41421L8.41422 7L13.364 11.9498Z",
    fill: "#FF1919"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCrossRed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cross-red.41a9d3d487f297cd9ec13051ae04b2bb.svg";